<template>
  <div class="agency">
    <div class="agency_head">
      <h5>Agence {{agency.display_name}}</h5>
      <p class="agency_organisation">
        <em>Organisation: {{agency.organization.display_name}}</em>
      </p>

    </div>
    <div class="agency_container">
      <div>
          <h6>Adresse</h6>
          <ul>
            <li>{{agency.street_line1}}</li>
            <li v-if="agency.street_line2">{{agency.street_line2}}</li>
            <li>{{agency.zipcode}} {{agency.city}}</li>
            <li>{{agency.state}} {{agency.decoded_country}}</li>
          </ul>
          <h6>Contact</h6>
          <ul>
            <li>Tél. : {{agency.phone}} </li>
            <li>Permanence téléphonique : {{agency.final_hotline_phone}} </li>

          </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"ValidationRequestableOrderOfferAgency",
  props:["agency"],
}
</script>
<style scoped>

.agency_head {
  border-bottom:solid 1px lightgrey;

}

.agency_container{
  display: flex;

}

.agency_address{

}

.agency_organisation {

}

.agency {
  /*width:50%;*/
  /*border-top: solid 1px lightgrey;*/
  padding: 0px 15px 0px 15px;
  /*width:30%;*/
  /*width: 25%;*/
  /*width: -webkit-fill-available;*/
}

@media screen and (max-width:800px){
  .agency {
    /*width:100%;*/
    margin-top: 15px;
    border-top: solid 1px lightgrey;
    padding: 0px 15px 0px 15px;
    display: block;
    /*width:30%;*/
    /*width: 25%;*/
    /*width: -webkit-fill-available;*/
  }

}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Contract/Agency.vue